<sgt-accordion [settings]="{ isCollapsed: true, expanded: true }">
  <div header>
    <span class="pct-table__title">Portfólios</span>
  </div>
  <ng-container *ngIf="portfolios.length > 0; else empty">
    <div class="pct-table" [class.pct-table--disabled]="disabled">
      <table class="pct-table__table">
        <thead class="pct-table__thead">
          <tr>
            <th class="pct-table__th pct-table__th--name">
              Portfólio → Categoria
            </th>
            <th class="pct-table__th pct-table__th--relevancia">Relevância</th>
          </tr>
        </thead>

        <tbody>
          <ng-container *ngFor="let portfolio of portfolios">
            <tr
              class="pct-table__row pct-table__row--portfolio"
              [class.pct-table__row--selected]="portfolio.selecionado"
            >
              <td class="pct-table__td pct-table__td--name">
                <div class="pct-table__cell-content">
                  <div class="pct-table__label">
                    <input
                      type="checkbox"
                      class="pct-table__checkbox"
                      [checked]="portfolio.selecionado"
                      [disabled]="disabled"
                      (change)="togglePortfolio(portfolio)"
                    />
                    <span
                      class="pct-table__name pct-table__name--portfolio"
                      [class.pct-table__name--selected]="portfolio.selecionado"
                    >
                      {{ portfolio.nomePortfolio }}
                    </span>
                  </div>
                  <button
                    type="button"
                    class="pct-table__collapse-btn"
                    (click)="toggleCollapse(portfolio)"
                    [title]="portfolio.collapsed ? 'Expandir' : 'Recolher'"
                  >
                    <i
                      class="fas"
                      [class.fa-chevron-up]="!portfolio.collapsed"
                      [class.fa-chevron-down]="portfolio.collapsed"
                    ></i>
                  </button>
                </div>
              </td>
              <td class="pct-table__td pct-table__td--relevancia">
                <sgt-select
                  [(ngModel)]="portfolio.relevancia"
                  [options]="relevanciaSelectOptions"
                  [settings]="{ isDisabled: !portfolio.selecionado || disabled }"
                  (selectedValueChanged)="emitSelecionados()"
                ></sgt-select>
              </td>
            </tr>

            <ng-container *ngIf="!portfolio.collapsed">
              <tr
                class="pct-table__row pct-table__row--categoria"
                *ngFor="let categoria of portfolio.categorias"
                [class.pct-table__row--selected]="categoria.selecionado"
                [class.pct-table__row--muted]="!categoria.selecionado"
              >
                <td class="pct-table__td pct-table__td--name">
                  <div class="pct-table__label pct-table__label--indented">
                    <input
                      type="checkbox"
                      class="pct-table__checkbox"
                      [checked]="categoria.selecionado"
                      [disabled]="disabled"
                      (change)="toggleCategoria(categoria, portfolio)"
                    />
                    <span
                      class="pct-table__name pct-table__name--categoria"
                      [class.pct-table__name--selected]="categoria.selecionado"
                      [class.pct-table__name--muted]="!categoria.selecionado"
                    >
                      {{ categoria.nomeCategoria }}
                    </span>
                  </div>
                </td>
                <td class="pct-table__td pct-table__td--relevancia">
                  <sgt-select
                    [(ngModel)]="categoria.relevancia"
                    [options]="relevanciaSelectOptions"
                    [settings]="{
                      isDisabled: !categoria.selecionado || disabled,
                      placeholder: '-'
                    }"
                    (selectedValueChanged)="emitSelecionados()"
                  ></sgt-select>
                </td>
              </tr>
            </ng-container>
          </ng-container>
        </tbody>

        <tfoot class="pct-table__tfoot" *ngIf="portfolios.length > 0">
          <tr>
            <td class="pct-table__footer-cell" colspan="3">
              {{ totalPortfoliosSelecionados }}
              {{
                totalPortfoliosSelecionados === 1 ? 'portfólio' : 'portfólios'
              }}
              e
              {{ totalCategoriasSelecionadas }}
              {{
                totalCategoriasSelecionadas === 1 ? 'categoria' : 'categorias'
              }}
            </td>
          </tr>
        </tfoot>
      </table>
    </div>
  </ng-container>
  <ng-template #empty>
    <p>Não foi encontrado nenhum portfólio <strong>ATIVO</strong></p>
  </ng-template>
</sgt-accordion>
